import React from 'react';

export function PresentationChartIcon() {
  return (
    <svg width="25" height="24" viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M22.0996 2.75H2.09961C1.68961 2.75 1.34961 2.41 1.34961 2C1.34961 1.59 1.68961 1.25 2.09961 1.25H22.0996C22.5096 1.25 22.8496 1.59 22.8496 2C22.8496 2.41 22.5096 2.75 22.0996 2.75Z"
        fill="currentColor"
      />
      <path
        d="M16.7699 22.34C16.6399 22.6 16.3699 22.75 16.0999 22.75C15.9899 22.75 15.8699 22.72 15.7699 22.67L12.0999 20.84L8.42987 22.67C8.32987 22.72 8.20987 22.75 8.09987 22.75C7.82987 22.75 7.55987 22.6 7.42987 22.34C7.23987 21.96 7.38987 21.51 7.76987 21.33L11.3499 19.54V17H12.8499V19.54L16.4299 21.33C16.8099 21.51 16.9599 21.96 16.7699 22.34Z"
        fill="currentColor"
      />
      <path
        d="M3.09961 2V14.1C3.09961 16 4.09961 17 5.99961 17H18.1996C20.0996 17 21.0996 16 21.0996 14.1V2H3.09961ZM17.0796 8.58L13.9296 11.21C13.6396 11.45 13.2696 11.55 12.9196 11.49C12.5596 11.43 12.2496 11.21 12.0596 10.89L11.0096 9.14L8.07961 11.58C7.93961 11.7 7.76961 11.75 7.59961 11.75C7.38961 11.75 7.16961 11.66 7.01961 11.48C6.74961 11.16 6.79961 10.69 7.11961 10.42L10.2696 7.79C10.5596 7.55 10.9296 7.45 11.2796 7.51C11.6396 7.57 11.9496 7.79 12.1396 8.11L13.1896 9.86L16.1196 7.42C16.4396 7.15 16.9096 7.2 17.1796 7.52C17.4396 7.84 17.3996 8.31 17.0796 8.58Z"
        fill="currentColor"
      />
    </svg>
  );
}
